// @flow

import React from "react";
import classNames from "classnames";

import options from "../utils/options";
import ComboBox from "../../combobox";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./select.scss";

export type SelectWidgetState = $Exact<{
  touched: boolean,
}>;

export class SelectWidget extends React.Component<SchemaTableWidgetProps<any>, SelectWidgetState> {
  state = {
    touched: false,
  };

  componentDidUpdate(prevProps: SchemaTableWidgetProps<any>) {
    // this will only happen as part of a request to hide errors
    if (!this.props.touched && prevProps.touched) {
      this.setState({ touched: false });
    }
  }

  get options() {
    return (this.props.oneOf || []).map(o => ({
      label: o.title,
      value: o.const,
    }));
  }

  get key() {
    return this.props.type === "object" ? (this.props.data || {}).id : this.props.data;
  }

  get value() {
    return (this.options.find(o => o.value === this.key) || {}).value;
  }

  get displayValue() {
    return (this.options.find(o => o.value === this.key) || {}).label;
  }

  hasUiSchemaError = (data: any): boolean => {
    if (!this.state.touched) {
      return false;
    }

    return !data;
  };

  hasError = (value: string): boolean => {
    return !!this.props.error || this.hasUiSchemaError(value);
  };

  handleChange = (option: Object): void => {
    this.setState({ touched: true });
    this.props.onChange(this.props.type === "object" ? { id: option } : option);
  };

  render() {
    if (!this.props.active) {
      return <div className="select__readonly">{this.displayValue}</div>;
    }

    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    return (
      <div
        className={classNames("select__container", {
          "select__container--disabled": disabled,
          "select__container--error": this.hasError(this.props.data),
        })}
      >
        <ComboBox
          className="w-100"
          options={this.options}
          value={this.value}
          onChange={this.handleChange}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default SelectWidget;
